import { capitalize } from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";

/**
 * PaywallModal Component
 *
 * Paywall dialog preventing free tier users from accessing premium perks.
 * Displays pricing for Standard ($100/year) and Premium ($300/year) plans
 * and comparison information. Handles special cases like AWS 5K perk (Standard only).
 * Features upgrade buttons linking to payment flow.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.show - Controls modal visibility
 * @param {Function} props.onHide - Close modal callback
 * @param {string} props.selectedPerk - Selected perk object
 * @param {string} props.paywallType - Type of paywall (determines messaging)
 * @param {string} props.userTierName - Current user subscription tier
 * @returns {JSX.Element} Paywall modal with pricing and upgrade options
 */
const PaywallModal = ({
  show,
  onHide,
  selectedPerk,
  paywallType,
  userTierName,
}) => {
  const [price, setPrice] = useState("");

  // Check if it’s the AWS 5K perk special case
  const isStandardOnlyPerk =
    selectedPerk?.id?.toLowerCase() === "aws5k" &&
    selectedPerk?.bundleTiers?.length === 1 &&
    selectedPerk?.bundleTiers[0] === "standard";

  useEffect(() => {
    if (paywallType === "standard") {
      setPrice("100");
    } else if (paywallType === "premium") {
      setPrice("300");
    }
  }, [paywallType]);

  return (
    <Modal
      className="modal-div"
      show={show}
      onHide={onHide}
      fullscreen="sm-down"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton style={{ borderBottom: "none" }} />
      <Modal.Body>
        {/* <Alert className="error-message" variant="danger" style={{ fontSize: "16px" }}>
                    <BsExclamationTriangle /> Sorry, this feature is not included in your {capitalize(userTierName)} Plan
                </Alert> */}

        <p
          style={{ textAlign: "center", fontWeight: "bold", fontSize: "18px" }}
        >
          Get started with {capitalize(paywallType)} Plan at USD ${price} per
          year
        </p>

        <div style={{ textAlign: "center" }}>
          <a
            href="https://www.roiquant.com/pricing"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="modal-compare glintanimation">
              {selectedPerk?.actionLabel === "Apply now"
                ? "Buy & apply for perks now"
                : "Buy & redeem perks now"}
            </Button>
          </a>
        </div>

        <hr style={{ margin: "1.5rem 0" }} />

        <p style={{ fontWeight: "bold", marginBottom: "0" }}>Things to know:</p>

        <ul className="modal-list">
          {isStandardOnlyPerk ? (
            <li>Perks are exclusively available to roiquant customers</li>
          ) : (
            <li>Perks are exclusively available to roiquant customers</li>
          )}
          <li>
            Once payment is made, there is{" "}
            <a
              href="https://viewpoints.roiquant.com/refund-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              no refund
            </a>
          </li>
          <li>Downgrade your subscription plan at any time</li>
          <li>
            If you downgrade or cancel to the Free Plan, you will only be able
            to redeem the perks until your annual paid plans (
            <i>Premium or Enterprise</i>) expires (<i>from date of payment</i>)
          </li>
        </ul>

        {/* <div style={{ textAlign: "center" }}>
                    <a href="#" target="_blank" rel="noopener noreferrer">
                        <Button className="modal-product glintanimation">Learn more about the product</Button>
                    </a>
                </div> */}
      </Modal.Body>
    </Modal>
  );
};

export default PaywallModal;
